/* eslint-disable import/prefer-default-export */
export const categoryNamesFromIds = (categoryIds, categories) =>
  categoryIds
    ? categories
        .filter((c) => categoryIds.includes(c.id))
        .map((c) => c.name)
        .sort()
        .join(', ')
    : '';
